import { Typography } from '@mui/material'
import React from 'react'

import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { PRICE } from '@f-fertighaus/applications/Next/utils/price'

export const PriceInEuroLabel = ({ children }: { children?: number }) => {
  return (
    <Typography variant='caption' fontWeight='fontWeightBold'>
      {children
        ? t('houseDetailPage.houseOverview.price', {
            price: PRICE.formatPrice(children)
          })
        : t('houseDetailPage.houseOverview.price-missing')}
    </Typography>
  )
}
